import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const StatisticsClients = (props) => {
  const [loading, setLoading] = useState(true);
  const [sygns, setSygns] = useState([]);
  const [courts, setCourts] = useState([]);
  const [sygnsCount, setSygnsCount] = useState(0);
  const [clientsFirst, setClientsFirst] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const getActualCourtForClient = (data, clientId) => {
    var sygnsA =
      data.filter(
        (el1) =>
          +el1.clientId === +clientId &&
          !el1.court.toString().toLowerCase().includes("apel")
      ).length > 0
        ? data.filter(
            (el1) =>
              +el1.clientId === +clientId &&
              !el1.court.toString().toLowerCase().includes("apel")
          )
        : data.filter((el1) => +el1.clientId === +clientId);
    sygnsA.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });

    return sygnsA.length > 0
      ? sygnsA[0].court !== ""
        ? sygnsA[0].court
        : "brak danych"
      : "brak danych";
  };

  const getActualCourtForClientId = (data, clientId) => {
    var sygnsA =
      data.filter(
        (el1) =>
          +el1.clientId === +clientId &&
          !el1.court.toString().toLowerCase().includes("apel")
      ).length > 0
        ? data.filter(
            (el1) =>
              +el1.clientId === +clientId &&
              !el1.court.toString().toLowerCase().includes("apel")
          )
        : data.filter((el1) => +el1.clientId === +clientId);
    sygnsA.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });

    return sygnsA.length > 0
      ? sygnsA[0].court !== ""
        ? sygnsA[0].court
        : "brak danych"
      : "brak danych";
  };

  const createExcelStatus = () => {
    var tab = [];
    tab.push(["Lp.", "Status", "Liczba", "% udziału"]);
    statuses.map((el, index) => {
      tab.push([
        index + 1,
        el.name,
        props.clients.filter((el) => el.status === el.name).length,
        (
          (props.clients.filter((el) => el.status === el.name).length /
            props.clients.length) *
          100
        ).toFixed(0) + "%",
      ]);
    });

    return tab;
  };

  const createExcelType = () => {
    var tab = [];
    tab.push(["Lp.", "Rodzaj", "Liczba", "% udziału"]);
    tab.push([
      "1",
      "pozew przeciwko bankowi",
      props.clients.filter((el) => el.status === "pozew przeciwko bankowi")
        .length,
      (
        (props.clients.filter((el) => el.status === "pozew przeciwko bankowi")
          .length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "2",
      "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału",
      props.clients.filter(
        (el) =>
          el.status ===
          "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału"
      ).length,
      (
        (props.clients.filter(
          (el) =>
            el.status ===
            "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "3",
      "pozew banku o opłatę za korzystanie z kapitału",
      props.clients.filter(
        (el) => el.status === "pozew banku o opłatę za korzystanie z kapitału"
      ).length,
      (
        (props.clients.filter(
          (el) => el.status === "pozew banku o opłatę za korzystanie z kapitału"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "4",
      "pozew banku z tytułu wypowiedzenia umowy",
      props.clients.filter(
        (el) => el.status === "pozew banku z tytułu wypowiedzenia umowy"
      ).length,
      (
        (props.clients.filter(
          (el) => el.status === "pozew banku z tytułu wypowiedzenia umowy"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "5",
      "pozew banku o waloryzację",
      props.clients.filter((el) => el.status === "pozew banku o waloryzację")
        .length,
      (
        (props.clients.filter((el) => el.status === "pozew banku o waloryzację")
          .length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "6",
      "pozew banku o zwrot kapitału",
      props.clients.filter((el) => el.status === "pozew banku o zwrot kapitału")
        .length,
      (
        (props.clients.filter(
          (el) => el.status === "pozew banku o zwrot kapitału"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "7",
      "sankcja kredytu darmowego",
      props.clients.filter((el) => el.status === "sankcja kredytu darmowego")
        .length,
      (
        (props.clients.filter((el) => el.status === "sankcja kredytu darmowego")
          .length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "8",
      "pozew banku o zwrot kapitału i jego waloryzację",
      props.clients.filter(
        (el) => el.status === "pozew banku o zwrot kapitału i jego waloryzację"
      ).length,
      (
        (props.clients.filter(
          (el) =>
            el.status === "pozew banku o zwrot kapitału i jego waloryzację"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "9",
      "EURO - pozew przeciwko bankowi",
      props.clients.filter(
        (el) => el.status === "EURO - pozew przeciwko bankowi"
      ).length,
      (
        (props.clients.filter(
          (el) => el.status === "EURO - pozew przeciwko bankowi"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "10",
      "WIBOR - pozew przeciwko bankowi",
      props.clients.filter(
        (el) => el.status === "WIBOR - pozew przeciwko bankowi"
      ).length,
      (
        (props.clients.filter(
          (el) => el.status === "WIBOR - pozew przeciwko bankowi"
        ).length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);
    tab.push([
      "11",
      "antywindykacja",
      props.clients.filter((el) => el.status === "antywindykacja").length,
      (
        (props.clients.filter((el) => el.status === "antywindykacja").length /
          props.clients.length) *
        100
      ).toFixed(0) + "%",
    ]);

    return tab;
  };

  const exportToExcelType = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelType());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const exportToExcelStatus = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelStatus());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const createExcelBank = () => {
    var tab = [];
    tab.push(["Lp.", "Status", "Liczba", "% udziału"]);
    props.banksData
      .filter((el) => el.team.includes("1"))
      .map((el, index) => {
        tab.push([
          index + 1,
          el.name,
          props.clients.filter((el1) => el1.bank === el.name).length,
          (
            (props.clients.filter((el1) => el1.bank === el.name).length /
              props.clients.length) *
            100
          ).toFixed(0) + "%",
        ]);
      });
    return tab;
  };

  const exportToExcelBank = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelBank());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const createExcelCourt = () => {
    var tab = [];
    tab.push(["Lp.", "Status", "Liczba", "% udziału"]);
    courts.map((el, index) => {
      tab.push([index + 1, el.court, el.count, el.percent]);
    });
    return tab;
  };

  const exportToExcelCourt = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelCourt());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const getFirstCourt = (id_old) => {
    var client = props.clients.filter((el) => el.id_old === id_old)[0];
    var sygnsC = sygns.filter((el2) => +el2.clientId === +client.id);
    sygnsC = sygnsC.sort(function (a, b) {
      return new Date(a.date) - new Date(b.date);
    });

    var court = sygnsC[0].court;

    if (court.toString().toLowerCase().includes("apel") === true) {
      var okr = sygnsC.filter((el) =>
        el.court.toString().toLowerCase().includes("okręg")
      );
      if (okr.length > 0) {
        court = okr[0].court;
      } else {
        court = sygnsC[1].court;
      }
    }
    return court;
  };

  const getCourtForClients = (sygns) => {
    try {
      var status = [];
      var counter = 0;
      var cF = [];
      console.log(sygns);

      props.clients.map((el) => {
        var sygnsC = sygns.filter((el2) => +el2.clientId === +el.id);
        if (sygnsC.length > 0) {
          sygnsC = sygnsC.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });

          console.log(sygnsC);
          var court = sygnsC[0].court;

          if (court.toString().toLowerCase().includes("apel") === true) {
            var okr = sygnsC.filter((el) =>
              el.court.toString().toLowerCase().includes("okręg")
            );
            if (okr.length > 0) {
              court = okr[0].court;
            } else {
              court = sygnsC[1] ? sygnsC[1].court : sygnsC[0].court;
            }
          }
          status.push(court === "brak" ? "brak danych" : court);
          cF.push({
            client: el.id,
            court: court === "brak" ? "brak danych" : court,
          });
          counter++;
        }
      });
      setSygnsCount(counter);
      var toRet = [];

      status.filter(onlyUnique).map((el) => {
        var count = cF.filter((el2) => el2.court === el).length;
        var count = count;
        var percent = ((count / props.clients.length) * 100).toFixed(0) + "%";

        toRet.push({
          court: el,
          count: count,
          percent: percent,
        });
      });
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
    return toRet;
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSygns(data);
        setCourts(getCourtForClients(data));
        fetchStatuses();
      })
      .catch((error) => {
        fetchStatuses();
      });
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    fetchClientsSygn();
  };

  useEffect(() => {
    getData();
  }, []);

  const clientsData = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>STATUSY SPRAW</p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelStatus}
        >
          EXPORT
        </button>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Status</th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <>
          {statuses.map((el, index) => (
            <tr>
              <td>{index + 1}</td>
              <td>{el.name}</td>
              <td>
                {props.clients.filter((eq) => eq.status === el.name).length}
              </td>
              <td>
                {(
                  (props.clients.filter((eq) => eq.status === el.name).length /
                    props.clients.length) *
                  100
                ).toFixed(0)}
                %
              </td>
            </tr>
          ))}
        </>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma spraw: {props.clients.length}</p>
    </>
  );

  const clientsData2 = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>BANKI</p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelBank}
        >
          EXPORT
        </button>
      </div>
      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Bank</th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <>
          {props.banksData
            .filter((el) => el.team.includes("1"))
            .map((el, index) => (
              <>
                <tr>
                  <td>{index + 1}</td>
                  <td>{el.name}</td>
                  <td>
                    {props.clients.filter((el1) => el1.bank === el.name).length}
                  </td>
                  <td>
                    {(
                      (props.clients.filter((el1) => el1.bank === el.name)
                        .length /
                        props.clients.length) *
                      100
                    ).toFixed(0)}
                    %
                  </td>
                </tr>
              </>
            ))}
        </>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma spraw: {props.clients.length}</p>
    </>
  );

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const clientsData3 = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>SĄDY</p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelCourt}
        >
          EXPORT
        </button>
      </div>
      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>
            Sąd<datagrid></datagrid>
          </th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <>
          {courts.map((el, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el.court}</td>
                <td>{el.count}</td>
                <td>{el.percent}</td>
              </tr>
            </>
          ))}
        </>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma spraw: {sygnsCount}</p>
    </>
  );

  const clientsData4 = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>RODZAJE SPRAW</p>{" "}
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcelType}
        >
          EXPORT
        </button>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Rodzaj</th>
          <th>Liczba</th>
          <th>% udziału</th>
        </tr>
        <>
          <tr>
            <td>1</td>
            <td>pozew przeciwko bankowi</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "pozew przeciwko bankowi"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "pozew przeciwko bankowi"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>
              pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału
            </td>
            <td>
              {
                props.clients.filter(
                  (el) =>
                    el.type ===
                    "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) =>
                    el.type ===
                    "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>pozew banku o opłatę za korzystanie z kapitału</td>
            <td>
              {
                props.clients.filter(
                  (el) =>
                    el.type === "pozew banku o opłatę za korzystanie z kapitału"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) =>
                    el.type === "pozew banku o opłatę za korzystanie z kapitału"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>4</td>
            <td>pozew banku z tytułu wypowiedzenia umowy</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "pozew banku z tytułu wypowiedzenia umowy"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "pozew banku z tytułu wypowiedzenia umowy"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>5</td>
            <td>pozew banku o waloryzację</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "pozew banku o waloryzację"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "pozew banku o waloryzację"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>6</td>
            <td>pozew banku o zwrot kapitału</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "pozew banku o zwrot kapitału"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "pozew banku o zwrot kapitału"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>7</td>
            <td>sankcja kredytu darmowego</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "sankcja kredytu darmowego"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "sankcja kredytu darmowego"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>8</td>
            <td>pozew banku o zwrot kapitału i jego waloryzację</td>
            <td>
              {
                props.clients.filter(
                  (el) =>
                    el.type ===
                    "pozew banku o zwrot kapitału i jego waloryzację"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) =>
                    el.type ===
                    "pozew banku o zwrot kapitału i jego waloryzację"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>9</td>
            <td>EURO - pozew przeciwko bankowi</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "EURO - pozew przeciwko bankowi"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "EURO - pozew przeciwko bankowi"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>10</td>
            <td>WIBOR - pozew przeciwko bankowi</td>
            <td>
              {
                props.clients.filter(
                  (el) => el.type === "WIBOR - pozew przeciwko bankowi"
                ).length
              }
            </td>
            <td>
              {(
                (props.clients.filter(
                  (el) => el.type === "WIBOR - pozew przeciwko bankowi"
                ).length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
          <tr>
            <td>11</td>
            <td>antywindykacja</td>
            <td>
              {
                props.clients.filter((el) => el.type === "antywindykacja")
                  .length
              }
            </td>
            <td>
              {(
                (props.clients.filter((el) => el.type === "antywindykacja")
                  .length /
                  props.clients.length) *
                100
              ).toFixed(0)}
              %
            </td>
          </tr>
        </>
      </table>
      <p style={{ fontSize: "0.8vw" }}>Suma spraw: {props.clients.length}</p>
    </>
  );

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {clientsData}
          {clientsData4}
          {clientsData2}
          {clientsData3}
        </>
      )}
    </div>
  );
};

export default StatisticsClients;
